export const DATE_FORMAT = 'MM/dd/yyyy';

export const CALENDAR_INPUT_CLASS_NAME = 'calendar-input';

export const CALENDAR_INVALID_CLASS_NAME = 'calendar-invalid';
